import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";
import { makeAdditionalSearchableFeature } from "@navigationRouting/utils";

import type { I18nT } from "@lib/dashboardI18n";

const CatalogsNRO = lazy(() =>
  import("@scenes/Catalogs/CatalogsNRO").then((module) => ({
    default: module.CatalogsNRO,
  }))
);

export const catalogsNRO: NavigationRoutingObject = {
  Component: CatalogsNRO,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("catalogs-menu-option", "Catalogs"),
  pageNameForTracking: () => "Catalogs",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("catalogs-description-nav", "Import and manage non-user data, such as product information"),
  icon: "nav-system-catalog",
  getDeveloperNavigationAllowed: () => true,
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: (t: I18nT<"dashboard-navigation">) => ({
    catalogs: makeAdditionalSearchableFeature({
      heading: t("catalogs-menu-option", "Catalogs"),
      pathname: "/dashboard/catalogs/:catalogId/:appGroupId",
      description: t("catalogs-description-nav", "Import and manage non-user data, such as product information"),
      query: { catalogId: "catalogs" },
      additionalSearchTerms: [],
    }),
  }),
  defaultRoute: "/dashboard/catalogs/:appGroupId",
};
